import type { FaqSection } from '../lib/faqContent';

interface FaqSectionViewProps {
  section: FaqSection;
}

export function FaqSectionView({ section }: FaqSectionViewProps) {
  return (
    <section id={section.id} style={{ paddingBottom: 32, scrollMarginTop: 24 }}>
      <h2
        className="text-xl font-semibold"
        style={{ letterSpacing: '-0.01em', marginBottom: section.intro ? 8 : 14 }}
      >
        {section.title}
      </h2>
      {section.intro && (
        <div style={{ marginBottom: 14, fontSize: 14, lineHeight: 1.5 }}>
          {section.intro}
        </div>
      )}
      <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 4 }}>
        {section.questions.map((qa, i) => (
          <li key={i}>
            <details
              style={{
                borderBottom: '1px solid var(--color-divider)',
                paddingTop: 4,
                paddingBottom: 4,
              }}
            >
              <summary
                style={{
                  listStyle: 'none',
                  cursor: 'pointer',
                  padding: '12px 0',
                  fontSize: 15,
                  fontWeight: 500,
                  color: 'var(--color-primary)',
                  display: 'flex',
                  alignItems: 'flex-start',
                  justifyContent: 'space-between',
                  gap: 12,
                  lineHeight: 1.4,
                }}
              >
                <span>{qa.q}</span>
                <span
                  aria-hidden
                  style={{
                    flexShrink: 0,
                    width: 18,
                    height: 18,
                    color: 'var(--color-text-secondary)',
                    transition: 'transform 0.15s',
                    marginTop: 3,
                  }}
                  className="faq-chevron"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </span>
              </summary>
              <div
                style={{
                  paddingTop: 4,
                  paddingBottom: 16,
                  paddingRight: 30,
                  fontSize: 14,
                  color: 'var(--color-text-secondary)',
                  lineHeight: 1.6,
                }}
                className="faq-answer"
              >
                {qa.a}
              </div>
            </details>
          </li>
        ))}
      </ul>
    </section>
  );
}
